// extracted by mini-css-extract-plugin
module.exports = {"item-link":"related-categories-unit_item-link__5wQF4"};